module.exports = __webpack_public_path__ + "img/email.e50c3f63.png";